<template lang="pug">
  v-container(fluid class="pt-0")
    PageMainCard(
      :advertItem="advertItem",
      :title="setCardTitle",
      :city="setCity",
      :price="setPrice",
      :duration="setDuration",
      :isAuthorAdvert="isAuthorAdvert")
    v-row
      v-col(cols="9")
        PageDescription(:advertItem="advertItem")
        v-divider(class="mb-6")
        v-row(no-gutters class="mb-6")
          AdvertsMap(
            v-if="advertItem.point",
            :point="advertItem.point",
            style="height: 350px; border-radius: 6px;")
        v-row(no-gutters)
          v-img(
            :src="require('@/assets/banners/banner-advert-page-horizontal.svg')",
            style="border-radius: 6px;")
      v-col(cols="3")
        div(class="banner")
          v-img(
            :src="require('@/assets/banners/banner-advert-page-vertical.jpg')",
            style="border-radius: 3px;")
</template>

<script>
export default {
  name: 'AdvertPage',
  components: {
    PageDescription: () => import('@/components/Adverts/PageDescription'),
    PageMainCard: () => import('@/components/Adverts/PageMainCard'),
    AdvertsMap: () => import('@/components/Adverts/AdvertsMap')
  },
  created() {
    this.$store.dispatch('GET_ADVERT_ITEM', this.$route.params.id)
    this.$store.dispatch('INCREASE_NUMBER_OF_VIEWS', this.$route.params.id)
  },
  computed: {
    advertItem() {
      return this.$store.state.advertItem
    },
    isAuthorAdvert() {
      return this.$store.getters.isAuthorAdvert(this.advertItem.id)
    },
    setAdvertType() {
      if (this.advertItem.rent) return 'Аренда'
      else return 'Продажа'
    },
    setCountRooms() {
      let result = null
      if (this.advertItem.items && this.advertItem.items.length) {
        result = this.advertItem.items.find(
          item => item.title === 'Кол-во комнат'
        )
      }
      if (result) {
        return result.value + '-комнатной квартиры'
      } else {
        return 'квартиры'
      }
    },
    setFloor() {
      let floor = null
      let totalFloors = null
      if (this.advertItem.items && this.advertItem.items.length) {
        floor = this.advertItem.items.find(item => item.title === 'Этаж')
        totalFloors = this.advertItem.items.find(
          item => item.title === 'Кол-во этажей в доме'
        )
      }
      if (floor && totalFloors) {
        return ', ' + floor.value + '/' + totalFloors.value + ' этаж'
      } else {
        return ''
      }
    },
    setArea() {
      let apartmentArea = null
      let houseArea = null
      let landArea = null
      let roomArea = null

      if (this.advertItem.items && this.advertItem.items.length) {
        apartmentArea = this.advertItem.items.find(
          item => item.title === 'Площадь квартиры'
        )
        houseArea = this.advertItem.items.find(
          item => item.title === 'Площадь дома'
        )
        landArea = this.advertItem.items.find(
          item => item.title === 'Площадь участка'
        )
        roomArea = this.advertItem.items.find(
          item => item.title === 'Площадь комнаты'
        )
      }
      if (apartmentArea) return `, ${apartmentArea.value} м2`
      if (houseArea) return `, ${houseArea.value} м2`
      if (roomArea) return `, ${roomArea.value} м2`
      if (landArea) return `, ${landArea.value} соток`
      else return ''
    },
    setCity() {
      let result = null
      if (this.advertItem.items && this.advertItem.items.length) {
        result = this.advertItem.items.find(item => item.title === 'Город')
      }
      if (result) return `${result.value}`
      else return null
    },
    setDuration() {
      let result = null
      if (
        this.advertItem.advertType === 'rentApartment' ||
        this.advertItem.advertType === 'rentHouse' ||
        this.advertItem.advertType === 'rentOther' ||
        this.advertItem.advertType === 'rentArea' ||
        this.advertItem.advertType === 'rentRoom'
      ) {
        if (this.advertItem.durationRent === 'longer') result = 'в месяц'
        else result = 'в сутки'
      }
      return result
    },
    setPrice() {
      let text = ''
      if (this.advertItem.price && this.advertItem.currencyText) {
        text = `${this.advertItem.price.toLocaleString('ru-Ru')} ${
          this.advertItem.currencyText
        }`
      } else {
        text = 'Цена договорная'
      }
      return text
    },
    setCardTitle() {
      let result

      if (
        this.advertItem.advertType === 'rentApartment' ||
        this.advertItem.advertType === 'sellApartment'
      ) {
        result = `${this.setAdvertType} ${this.setCountRooms}${this.setArea}${this.setFloor}`
      }

      if (
        this.advertItem.advertType === 'rentHouse' ||
        this.advertItem.advertType === 'sellHouse'
      ) {
        result = `${this.setAdvertType} дома${this.setArea}`
      }

      if (
        this.advertItem.advertType === 'rentArea' ||
        this.advertItem.advertType === 'sellArea'
      ) {
        result = `${this.setAdvertType} участка${this.setArea}`
      }

      if (this.advertItem.advertType === 'rentOther') {
        result = 'Аренда коммерческой недвижимости'
      }
      if (this.advertItem.advertType === 'sellOther') {
        result = 'Продажа коммерческой недвижимости'
      }

      if (this.advertItem.advertType === 'rentRoom') {
        result = `Аренда комнаты${this.setArea}`
      }

      return result
    }
  },
  methods: {
    deleteAdvert() {
      this.$store
        .dispatch('DELETE_ADVERT', {
          type: this.advertItem.advertType,
          id: this.advertItem.id
        })
        .then(result => {
          if (result) {
            this.$router.push('/')
          }
        })
    }
  }
}
</script>

<style scoped>
.banner {
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 1rem;
}
</style>
